const DataType = [
  { label: 'Text', value: 'string' },
  { label: 'True/False', value: 'boolean' },
  { label: 'Number', value: 'number' },
  { label: 'Date/Time', value: 'dateTime' },
  { label: 'Dropdown', value: 'dropDown' },
  { label: 'Object', value: 'object' },
  { label: 'Image', value: 'image' },
  { label: 'Location', value: 'location' },
  { label: 'Switch', value: 'switch' },
  { label: 'Slider', value: 'slider' },
  { label: 'Checkbox', value: 'checkBox' },
  { label: 'Checkbox Group', value: 'checkGroup' },
  { label: 'Radio Button', value: 'radioButton' },
  { label: 'Textarea', value: 'textArea' },
  { label: 'File Upload', value: 'file' },
  { label: 'DataSet Reference', value: 'dataSet' },
];

export default DataType;
